import type { MouseEvent } from 'react'

// import { Image } from '#/global/component/Image/Image'
import type { LANG, WithLoadingState } from '@eshop/type'

import i18n from './i18n'
import css from './index.module.css'

import { Pagination } from '#/global/component/Pagination/Pagination'

export interface ArticleObject {
    description?: string
    id: string
    item_name: string
    releaseDate?: Date
    url: string
}
interface Props {
    itemsCount: number
    lang: LANG
    list: ArticleObject[]
    onItemClick?: (event: MouseEvent<HTMLAnchorElement>, parameters: { code: string, link: string }) => void
    page: number
    setPage: (page: number) => void
}

export const ArticleList = ({ itemsCount, lang, list, loadingState, onItemClick, page, setPage }: WithLoadingState<Props>) => {
    // const imageResolutionList = [
    //     { width: 112, height: 134, maxWidth: 500 },
    //     { width: 162, height: 194, maxWidth: 768 },
    //     { width: 175, height: 211 },
    // ]
    const itemsPerPage = 20

    if (loadingState) {
        return (
            <div className={css.container} data-name="r-a-search r-article-list">
                <div className={`${css.pagination} ${css.top} loading`} />
                <div className={css.list}>
                    {/* {[...Array(itemsPerPage)].map((_, index) => (
                        <div className={css.item} key={index}>
                            <div className="loading">
                                <Image resolutionList={imageResolutionList} />
                            </div>
                            <div className={css.content}>
                                <h3 className={`${css.title} loading`} />
                                <div className={`${css.releaseDate} loading`} />
                                <div className={`${css.description} loading`} />
                                <div className={`${css.link} loading`} />
                            </div>
                        </div>
                    ))} */}
                    {Array.from({ length: itemsPerPage }).map((_, index) => (
                        <div key={index} className={css.item}>
                            <div className="loading" />
                        </div>
                    ))}
                </div>
            </div>
        )
    }

    const t = i18n[lang]

    return (
        <div className={css.container} data-name="r-a-search r-article-list">
            {itemsCount > itemsPerPage && (
                <div className={`${css.pagination} ${css.top}`}>
                    <Pagination itemsCount={itemsCount} itemsPerPage={itemsPerPage} page={page} setPage={setPage} />
                </div>
            )}
            {/* <div className={css.list}>
                {list.map((article) => (
                    <div className={css.item} key={article.id}>
                        <div>
                            <Image resolutionList={imageResolutionList} />
                        </div>
                        <div className={css.content}>
                            <h3 className={css.title}>{article.name}</h3>
                            <div className={css.releaseDate}>
                                {t.releaseDate}:{' '}
                                {article.releaseDate?.toLocaleDateString() ?? new Date().toLocaleDateString()}
                            </div>
                            <div className={css.description}>{article.description ?? 'description'}</div>
                            <a className={css.link} href={article.url}>
                                {t.moreInfo}
                            </a>
                        </div>
                    </div>
                ))}
            </div> */}
            <div className={css.list}>
                {list.map(article => (
                    <a key={article.id} className={css.item} href={article.url} onClick={event => onItemClick?.(event, { code: `${article.id}`, link: article.url })}>
                        <img
                            className={css.icon}
                            src="https://cdn1.idek.cz/file/link-325b064a.svg"
                            width={16}
                            height={16}
                        />
                        <div className={css.content}>
                            <div className={css.title}>{article.item_name}</div>
                            <div className={css.show}>
                                <div>{t.show}</div>
                                <img
                                    className={css['show-icon']}
                                    src="https://cdn1.idek.cz/file/arrow-left-circle-7328df09.svg"
                                    width={14}
                                    height={14}
                                />
                            </div>
                        </div>
                    </a>
                ))}
            </div>
            {itemsCount > itemsPerPage && (
                <div className={css.pagination}>
                    <Pagination
                        itemsCount={itemsCount}
                        itemsPerPage={20}
                        page={page}
                        position="bottom"
                        setPage={setPage}
                    />
                </div>
            )}
        </div>
    )
}
